import React from "react";
import styled, { keyframes } from "styled-components";

// Skeleton 애니메이션
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Skeleton = styled.div`
  background: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  border-radius: 8px;
`;

const Wrapper = styled.div`
  padding: 0 16px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

const TotalStatCard = styled.div`
  margin-right: 0;
  margin-top: -4px;
`;

const TotalStatCardInner = styled.div`
  padding: 8px 4px 0px;
  border-radius: 12px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  background: #fff;
  position: relative;
`;

const StatCard = styled.div`
  height: 104px;
`;

const StatCardInner = styled.div`
  padding: 20px 16px;
  border-radius: 12px;
  background: #f9fafb;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 6px;
`;

const SkeletonTitle = styled(Skeleton)`
  height: 20px;
  width: 40%;
`;

const SkeletonValue = styled(Skeleton)`
  height: 24px;
  width: 70%;
  margin-bottom: 8px;
  border-radius: 8px;
`;

// const SkeletonChange = styled(Skeleton)`
//   height: 18px;
//   width: 32%;
//   border-radius: 6px;
// `;

// 메인 스켈레톤 컴포넌트
export const SalesDashboardSummarySkeleton = () => {
  return (
    <Wrapper>
      {/* 총 매출 카드 */}
      <TotalStatCard>
        <TotalStatCardInner>
          <SkeletonTitle />
          <SkeletonValue />
        </TotalStatCardInner>
      </TotalStatCard>

      {/* 4개 매출 카드 (2x2 grid) */}
      {/* <GridWrapper>
        {[1, 2, 3, 4].map((_, idx) => (
          <StatCard key={idx}>
            <StatCardInner>
              <SkeletonTitle />
              <SkeletonValue />
              <SkeletonChange />
            </StatCardInner>
          </StatCard>
        ))}
      </GridWrapper> */}
    </Wrapper>
  );
};
